import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-partner-apply-success',
  templateUrl: './partner-apply-success.component.html',
  styleUrls: ['./partner-apply-success.component.scss']
})
export class PartnerApplySuccessComponent  {}
